<template>
<div id="contact">
  <v-app id="contactapp">
    <v-row justify="center">
      <v-dialog v-model="dialog" content-class="contact-dialog">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('contact_query')}}</span>
              <v-btn text icon large color="primary" class="info-close-btn" @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-0">
              <v-col cols="12" sm="6" class="mb-0">
                <span class="p1">{{$t('address')}}</span>
                <p>Groupe E Celsius SA<br>
                    Route de Chantemerle 1<br>
                    1763 Granges-Paccot
                </p>
              </v-col>
              <v-col cols="12" sm="6" class="mb-0">
                <span class="p1">{{$t('opening_times')}}</span>
                <p>{{$t('opening_times1')}}<br>
                  {{$t('opening_times2')}}  
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-0">
              <v-col cols="6" sm="6" class="mb-0">
                <v-btn color="primary" rounded depressed large class="contact-btn" href="tel:+41263526800">
                  <v-icon left>mdi-phone</v-icon>
                 <span v-if="$vuetify.breakpoint.mdAndUp"> +41 26 352 68 00</span>
                </v-btn>
              </v-col>
              <v-col cols="6" sm="6" >
                <v-btn color="primary" rounded depressed large class="contact-btn" href="info@celsius.ch">
                  <v-icon left>mdi-email</v-icon>
                  <span v-if="$vuetify.breakpoint.mdAndUp">info@celsius.ch</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="mb-0">

            <v-col cols="12" class="mb-0">
            <p class="p1">{{$t('form')}}</p>

            <span v-if="error && showForm" style="color:red">{{ error }}</span>
            <span v-if="showForm">
                <v-text-field
                  v-model="lastname"
                  v-bind:label="$t('name')+' *'">
                </v-text-field>
                <v-text-field
                  v-model="firstname"
                  v-bind:label="$t('first_name')+' *'">
                </v-text-field>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  v-bind:label="$t('email')+' *'">
                </v-text-field>
                <v-text-field
                  v-model="phone"
                  v-bind:label="$t('phone')+' *'">
                </v-text-field>
                <v-textarea
                  v-model="message"
                  :rules="[rules.required]"
                  v-bind:label="$t('message')"
                  v-bind:hint="$t('message_hint')"
                ></v-textarea>
            </span>
            <span v-if="!showForm">
              <p style="color:#72A62D">{{$t('thank_you_message')}}</p>
            </span>     
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="showForm" rounded depressed large class="info-submit-btn" @click="send_action">{{$t('send')}}</v-btn>
            <v-btn color="primary" v-if="!showForm" rounded depressed large class="info-submit-btn" @click="closeDialog">{{$t('close')}}</v-btn>
          </v-card-actions>
        </v-card>

        
      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Contact',
  data () {
    return {
      dialog: false,
      show: false,
      showForm:true,
      email: '',
      lastname: '',
      firstname: '',
      message:'',
      phone: '',
      error: '',
      rules: {
          required: value => !!value || this.$t('mandatory'),
          min: v => v.length >= 8 || this.$t('password_hint'),
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('invalid_email')}
      },
    }
  },
  props: [ 'showCalculatorDialog' ],
  computed: {
  },
  methods: {
    send_action(){
      if (this.email.length < 1 || this.message.length < 1){
        this.error = this.$t('error_contact_form')
        return
      }
      var data = {}
      if (this.$store.userToken){
        data['token'] = this.$store.userToken
      }
      data['email'] = this.email
      data['lastname'] = this.lastname
      data['firstname'] = this.firstname
      data['phone'] = this.phone
      data['message'] = this.message
      data['lang'] = this.$store.lang
      data['map'] = ''
      if (this.$store.mapParameters && this.$store.mapParameters.hash){
          data['map'] = this.$store.mapParameters.hash
      }
      axios.post(this.$store.backendAPI+'contact/', data)
      .then(response => {
        if (response.status == 200){
          this.showForm = false

        }

      })
      .catch(e => {
        console.log(e)
         this.error = this.$t('error_send_contact_form')
      })
    },
    back() {
      return true
    },
    openDialog(){
      this.email = this.$store.userEmail
      this.lastname = ''
      this.firstname = ''
      this.message =''
      this.phone = ''
      this.error = ''
      this.address = ''
      this.dialog = true
      this.showForm = true
    },
    closeDialog(){
      this.dialog = false
    }
  }

}
</script>

